<div *ngIf="isShopListLoading" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only ">Loading...</span>
    </div>
</div>

<div id="main">
    <div class="toolbar-container" style="box-shadow: none; background-color: #eaf1f5;">
        <div class="" style="box-shadow: 0px 4px 4px #0000001f;">
            <ng-container *ngIf="is_openSearch">
                <div [formGroup]="searchForm" class="input-wrap"
                    style="display: inline-block; filter:none;background-color:white;">
                    <div class="d-flex m-3"
                        style="  border-radius: 10px; height:50px;box-shadow: 0px 4px 4px #0000001f;">
                        <div style="width: 40px;">
                            <span class="wraped-input-icon">
                                <span class="material-icons-outlined">
                                    search
                                </span>
                            </span>
                        </div>
                        <div style="flex-grow: 1;">
                            <input formControlName="search" type="text" placeholder="Search ..." class="form-control"
                                style="height: 100%; width: 100%; box-shadow: none !important; border: none; background-color: transparent;">
                        </div>
                        <div class="d-flex" style="width: 50px;">
                            <button
                                style="background: none; border: none; cursor: pointer; padding: 0; margin-left: 5px;"
                                aria-label="Clear search" (click)="clearSearch()">
                                <i class="fa fa-times" style="font-size: 16px; color: #000;"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="isExpandFilter">

                <div [formGroup]="filterForm" class="input-wrap"
                    style="display: inline-block; filter:none;background-color: white;">
                    <div class="m-3 d-flex flex-column" style="gap: 0.5rem;">
                        <!-- SHOP FILTER -->
                        <div class="row no-gutters ">
                            <div class="col-12 pr-1">
                                <ng-select #shopDropdown [items]="shopList" formControlName="shop" bindLabel="ShopName"
                                    [clearable]="true" placeholder="Shop" [searchable]="true" appendTo="body" (change)="onShopSelected($event.value)">
                                </ng-select>
                            </div>
                        </div>

                        <!-- DATE FILTER -->
                        <div class="row no-gutters">
                            <div class="col-6 pr-1">
                                <input formControlName="fromDate" class="form-control" type="date">
                            </div>
                            <div class="col-6 pl-1">
                                <input formControlName="toDate" class="form-control" type="date">
                            </div>

                        </div>
                        <div class="d-flex align-items-center justify-content-end " style="gap:0.5rem;">
                            <button (click)="clearFilter()" class="btn btn-outline-secondary w-100">Clear Filter</button>
                            <button (click)="applyFilter()" class="btn btn-primary w-100">Apply Filter</button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="bg-white border-top">
                <div class="px-3 py-2">
                    <div class="input-wrap d-flex flex-column filter-block">
                        <div class="d-flex flex-column content ">

                            <div *ngIf="summaryLoading; else realSummaryContent" class="d-flex align-items-center justify-content-between py-2 px-3">
                                <div class="d-flex flex-column align-items-center justify-content-center text-center" style="width: 33%;">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="skeleton-text short " style="height: 20px; width: 80px;"></div>
                                    </div>
                                    <div class="skeleton-text very-short" style="margin-top: -6px;width: 60px;"></div>
                                </div>

                                <div class="d-flex flex-column align-items-center justify-content-center text-center" style="width: 33%;">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="skeleton-text short" style="height: 20px; width: 80px;"></div>
                                    </div>
                                    <div class="skeleton-text very-short" style="margin-top: -6px; width: 60px;"></div>
                                </div>
                            
                                <div class="d-flex flex-column align-items-center justify-content-center text-center" style="width: 33%;">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="skeleton-text short" style="height: 20px; width: 80px;"></div>
                                    </div>
                                    <div class="skeleton-text very-short" style="margin-top: -6px; width: 60px;"></div>
                                </div>
                            </div>

                            <ng-template #realSummaryContent>
                                <div class="d-flex align-items-center justify-content-between py-2 px-3">
                                    <div class=" d-flex flex-column text-center">
                                        <div class="d-flex justify-content-center">
                                            <div>
                                                <h5>{{summary?.TotalPaid != null ? (summary?.TotalPaid | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h5>
                                            </div>
                                        </div>
                                        <div class="text-success" style="font-size: 13px; margin-top: -6px;">Total Paid<span style="color: #000;">({{outstandingReportData?.length}})</span>
                                        </div>
                                    </div>
    
                                    <div class=" d-flex flex-column text-center">
                                        <div class="d-flex justify-content-center">
                                            <div>
                                                <h5>{{summary?.TotalPayable!= null ? (summary?.TotalPayable | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h5>
                                            </div>
                                        </div>
                                        <div class="text-success" style="font-size: 13px; margin-top: -6px;">Total Payable<span style="color: #000;">({{outstandingReportData?.length}})</span>
                                        </div>
                                    </div>
    
                                    <div class=" d-flex flex-column text-center">
                                        <div class="d-flex justify-content-center">
                                            <div>
                                                <h5>{{summary?.TotalOutStanding!=null ? (summary?.TotalOutStanding | currency : 'INR' : 'symbol' : '1.0-0'): '--'}}</h5>
                                            </div>
                                        </div>
                                        <div class="text-success" style="font-size: 13px; margin-top: -6px;">Total Outstndng<span style="color: #000;">({{outstandingReportData?.length}})</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-white" style="padding: 8px 8px 25vh; min-height: 85vh;">
        <div class="list-container" infinite-scroll
            [infiniteScrollDistance]="scrollDistance" [infiniteScrollUpDistance]="scrollUpDistance"
            [infiniteScrollThrottle]="throttle" (scrolled)="onScroll()" style="overflow-y: auto;">

            <ng-container *ngIf="loading; else realContent">
                <div class="serviceItem d-flex p-2 my-3" *ngFor="let _ of [].constructor(5)">
                    <!-- Left Job Box -->
                    <div class="mr-2">
                        <div class="jobBox d-flex flex-column align-items-center justify-content-center p-2 skeleton-box"
                            style="width:80px; height:90px;">
                
                            <div class="skeleton-text very-short mb-1"></div>
                            <div class="d-flex align-items-center">
                                <div class="skeleton-text very-short"></div>
                            </div>
                
                        </div>
                    </div>
                
                    <!-- Right Content -->
                    <div class="row no-gutters w-100" style="overflow: hidden;">
                        <div class="d-flex align-items-center justify-content-between w-100">
                
                            <!-- Left Text Block -->
                            <div class="d-flex flex-column w-75">
                                <div class="skeleton-text short mb-1"></div>
                                <div class="skeleton-text very-short mb-1"></div>
                                <div class="skeleton-text short"></div>
                            </div>
                
                            <!-- Right Amount Block -->
                            <div class="d-flex flex-column align-items-end w-25">
                                <div class="skeleton-text very-short mb-1"></div>
                                <div class="skeleton-text short mb-1"></div>
                
                                <div class="skeleton-text very-short mb-1"></div>
                                <div class="skeleton-text short"></div>
                            </div>
                
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #realContent>
                <div *ngIf="outstandingReportData.length==0" class="no-data-message text-center ">
                    No shop report data found.
                </div>
                <ng-container *ngIf="outstandingReportData.length>0">
                    <div class="serviceItem d-flex p-2 my-3" *ngFor="let item of outstandingReportData">
                        <div class="row no-gutters w-100" style="overflow: hidden;">
                            <div class="d-flex flex-column justify-content-between w-100 ">
                                <div class="d-flex align-items-center justify-content-between w-100">
        
                                    <div class="d-flex flex-column col-9 p-0">
                                        <div class="customDate">
                                            {{parseUnixTimestamp(item?.TransactionDate).fullDate}}
                                            <span>{{parseUnixTimestamp(item?.TransactionDate).fullTime12}}</span>
                                        </div>
                                        <div class="d-flex align-items-start text-secondary " >
                                            <div class="two-line-ellipsis" style="font-size: 14px;max-width: 250px;"><span>Narration: </span> <span style="font-weight: 600;">{{item?.Narration}}</span> </div>
                                        </div>
                                    </div>
        
                                    <div class="col-3 p-0 h-100 d-flex flex-column align-items-end">
                                        <div *ngIf="+item?.Paid!==0" class="paymentStatus d-flex flex-column align-items-center">
                                            <span class="payment-chip paid" style="font-weight: 600;">
                                                Paid
                                            </span>
                                            <span style="font-weight: 600;">
                                                {{+item?.Paid | currency : 'INR' : 'symbol' : '1.0-0'}}
                                            </span>
                                        </div>
                                        <div *ngIf="+item?.Payable!==0" class="paymentStatus d-flex flex-column align-items-center">
                                            <span class="payment-chip payable" style="font-weight: 600;">
                                                Payable
                                            </span>
                                            <span style="font-weight: 600;">
                                                {{+item?.Payable | currency : 'INR' : 'symbol' : '1.0-0'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="d-flex align-items-start" style="font-size: 15px;">
                                    Outstndng: <strong> {{item?.OutStanding | currency : 'INR' : 'symbol' : '1.0-0'}}</strong>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </ng-container>
            </ng-template>

        </div>
    </div>
</div>